// eslint-disable-next-line
const apiHost = process.browser ? process.env.apiHostBrowser : process.env.apiHostServer;
// eslint-disable-next-line
const apiPath = process.env.apiPath;

export default `${apiHost}${apiPath}static-block`;
